module.exports = "/_next/static/images/edit-3c7f1fa40338b3d7011b2c1fa0ccee4c.png";